import Introduction from "../../componets/Introduction";

export default function Section2() {
  return (
    <div className="Section2">
      <Introduction
        title="Introduction"
        text="Mean3 offers IT Project Outsourcing service. We specialize in delivering high-quality, cost-effective solutions to help businesses like yours achieve their technology goals."
      />
    </div>
  );
}
